import { render } from "./CustomMessage.vue?vue&type=template&id=15e42095"
import script from "./CustomMessage.vue?vue&type=script&lang=js"
export * from "./CustomMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__